import { FormConfig } from "../../types/form";
import { Roles } from "../../constants/user";
import { queryBannerFields } from "../fields";

export const pendingPagesForm = (
  userRoles: Roles,
  fieldProps?: {
    portalRegions?: Array<any>;
  }
): FormConfig => {
  const config = {
    fields: [queryBannerFields.emailAddress],
  };

  if (fieldProps?.portalRegions && fieldProps.portalRegions.length > 0) {
    const portalRegionsField: any = queryBannerFields.portalRegion;

    portalRegionsField.options = fieldProps.portalRegions.map(
      (portalRegion) => ({
        displayText: portalRegion.portalHubName,
        value: portalRegion.cmsId,
      })
    );

    config.fields.push(portalRegionsField);
  }

  config.fields.push(queryBannerFields.fromDate);
  config.fields.push(queryBannerFields.toDate);

  return config;
};
